import { API_BASE_URL } from "../../../config/env";
import { AuthResponse } from "./types";

/**
 * Faz a requisição para o endpoint de auth do backend, traduzindo o token cognito para o token do backend.
 *
 * Exemplo de URL:
 *   POST http://localhost:8080/auth/cognito
 */
export const fetchAuthToken = async (
    cognitoIdToken: string
): Promise<AuthResponse> => {
    const response = await fetch(
        `${API_BASE_URL}/auth/cognito`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ id_token: cognitoIdToken }),
        }
    );

    if (!response.ok) {
        throw new Error(
            `Erro ao autenticar com token Cognito: ${response.status} ${response.statusText}`
        );
    }

    const data = await response.json();
    return data;
}




